import { set } from 'lodash';
import React, { useState, useEffect } from 'react';

const AutoCompleteInput = (p) => {
    useEffect(() => {
        if (p.initial) {
            document.getElementById(id).placeholder = p.initial;
        }
        const mt = p.match ?? [];
        setmatches((p.showAll ?? false) ? [...mt] : []);
        document.getElementById(id).value = "";
    }, [p.initial, p.match])

    const disabled = p.disabled ?? false;
    const style = p.style ?? 'wpx-250 relative'
    const inputClass = p.inputClass ?? ""
    const label = p.label;
    const id = p.id ?? ("text-" + (Math.random(8558) + 3));
    const match_arr = disabled ? [] : p.match ?? [];
    const text_class = p.text_class ?? 'text-bold text-s';
    const required = p.required ?? false;
    const showAll = p.showAll ?? false;
    const help_text = p.help_text && p.help_text.length == p.match.length ? p.help_text : null;

    const [matches, setmatches] = useState(showAll ? [...match_arr] : []);
    const [matches_help, setmatches_help] = useState([]);

    const autoComplete = (event) => {
        if (p.function) p.function(event.target.value);
        if (event.target.value === '') {
            setmatches([]);
            setmatches_help([]);
            return;
        }
        search((event.target.value.toLowerCase()));
        if (p.onChange) p.onChange(event);
    }

    const search = (value) => {
        let mt = [];
        let hlp = [];
        if (value === " ") {
            setmatches([...match_arr])
            if (help_text) setmatches_help([...help_text]);
            return;
        }

        for (let i = 0; i < match_arr.length; i++) {
            if ((match_arr[i].toLowerCase()).includes(value.toLowerCase().trim())) {
                mt.push(match_arr[i]);
                if (help_text) hlp.push(help_text[i]);
            }
        }

        setmatches(mt);
        if (help_text) setmatches_help(hlp);
    }

    const fill_field = (value) => {
        document.getElementById(id).value = value;
        setmatches([]);
        if (p.function) p.function(value);
    }


    return (
        <div className={style}>
            {<label className={text_class} style={{ position: "relative" }}>{label}</label>}
            <input type='text' className={'form-control form-control-sm ' + inputClass}
                disabled={disabled}
                name={p.name ?? 'size'}
                onChange={autoComplete}
                id={id}
                autoComplete='off'
                required={required} />
            {
                matches.length > 0 && <div className='row justify-content-center p-0 m-0 w-100 absolute' autoCapitalize="characters" style={{ zIndex: 2 }}>
                    <ul className='blur-xs p-2 round-xs shadow-multi text-center' style={{ maxHeight: "350px", overflow: 'auto' }}>
                        {
                            matches.map((match, i) => {
                                return (
                                    <li className='p-1 bg-black text-white dosis text-s round-xs ps-2 pe-2 pointer mt-1 scale-025 w-100 text-start'
                                        key={id + i}
                                        onClick={() => { fill_field(match) }}>
                                        {match} <span className={help_text ? "text-xs ms-2 text-300" : ""}>{help_text ? matches_help[i] : ""}</span>
                                    </li>
                                )
                            })
                        }

                    </ul>
                </div>
            }
        </div>
    )
}

export default AutoCompleteInput;